import { IonModal } from "@ionic/react";
import React, { FC } from "react";
import { OurBrainContent } from "../../../../../components";
import OurBrainForm from "../../../../../components/OurBrainForm";

const BugReport: FC<any> = ({ isOpen, actions }) => {
  return (
    <IonModal isOpen={isOpen}>
      <OurBrainContent sizeMd="11">
        <OurBrainForm
          formKey={process.env.REACT_APP_BRAIN_FORM_BUG!}
          modal={"bugreport"}
          backAction={() => actions.showModal({ modal: "bugreport" })}
        />
      </OurBrainContent>
    </IonModal>
  );
};

export default BugReport;
